import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import Swal from 'sweetalert2'
import {MultiSelect} from 'primereact/multiselect'

import withReactContent from 'sweetalert2-react-content'
import {useNavigate, useParams} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {Calendar} from 'primereact/calendar'
import moment from 'moment'

import makeAnimated from 'react-select/animated'
import CurrencyInput from 'react-currency-input-field'
import AsyncSelect from 'react-select/async'
import {colourStyles} from '../styles/styles'
import {
  deleteEvaluationReport,
  concludeEvaluationReport,
  updateEvaluationReport,
  viewEvaluationReport,
  enableEvaluationReport,
} from '../evaluationReport-list/core/_requests'
import {
  EvaluationReport,
  EvaluationReportInitValues as initialValues,
} from '../evaluationReport-list/core/_models'
import {insertDataTime} from '../../../../../../util/insertDataTime'
import {Toolbar2} from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import {PageTitle} from '../../../../../../_metronic/layout/core'
import {ModalCanceledReport} from '../evaluationReport-list/components/modal/ModalCanceledReport'
import {EvaluationIndemnityAreaList} from '../../../EvaluationIndemnityAreas/components/indemnityItems-list/IndemnityAreaList'
import {useQueryClient} from 'react-query'
import {KTSVG} from '../../../../../../_metronic/helpers'

//import {useToast} from '../../../../../../app/layout/hooks/toast'
const API_URL = process.env.REACT_APP_API_URL || 'api'
interface UseOption {
  readonly value: string
  readonly label: string
}

const evaluationReportSchema = Yup.object().shape({
  property_id: Yup.number().required('Campo obrigatório'),
  // issue_organ: Yup.number().required('Campo obrigatório'),
  // telephone: Yup.string().required('Campo obrigatório'),
  //descripton: Yup.string().required('Campo obrigatório'),
  // email: Yup.string().required('Campo obrigatório'),
})

const FormEvaluationReportEdit: React.FC = () => {
  const intl = useIntl()
  const MySwal = withReactContent(Swal)
  const navigate = useNavigate()
  const {uuid} = useParams()
  const queryClient = useQueryClient()
  const animatedComponents = makeAnimated()

  const [propertyID, setPropertyID] = useState([])
  const [issue_dateD, setissue_dateD] = useState<Date | undefined>(undefined)
  const [year, setYear] = useState<Date | undefined>(undefined)
  const [discount, setdiscount] = useState<any>()

  const [canceledReportModal, setCanceledReportModal] = useState(false)
  const [evaluation_report, setEvaluationReport] = useState<EvaluationReport>()
  const [selectedCostCenters, setSelectedCostCenters] = useState(null)
  const [costCenters, setCostCenters] = useState([])

  const [loading, setLoading] = useState(false)
  const [isConclude, setIsConclude] = useState(true)
  const [isOpening, setIsOpening] = useState(true)
  const [isCanceled, setIsCanceled] = useState(true)
  const [isDisabledEnable, setIsDisabledEnable] = useState(true)

  useEffect(() => {
    if (uuid) {
      getevaluationReport(uuid)
      loadOptionsCostCenters()
    }
    // eslint-disable-next-line
  }, [uuid])

  async function getEvaluationReportNumber(propertyID: number) {
    const {data} = await axios.get(
      `${API_URL}/sgt/v1/evaluation_reports/project_property?property_id=${propertyID}`
    )
    const date = new Date()
    let number = `${data.project_code} - ${date.getFullYear()} - ${
      data.evaluation_report_sequential
    }`
    formik.setFieldValue('evaluation_report_number', number)
  }

  const loadOptionsCostCenters = () => {
    setTimeout(() => {
      getCostcenters()
      let costCenters: any = []
      async function getCostcenters() {
        const {data} = await axios.get(API_URL + '/v1/cost_centers/select2')

        let Response = data.results
        if (Response) {
          for (const element of Response) {
            const costCenter: any = {
              code: element.id,
              name: `${element.name} - ${element.description}`,
            }
            costCenters.push(costCenter)
          }
        }
      }
      setCostCenters(costCenters)
      return costCenters
    }, 1000)
  }

  async function getevaluationReport(uuid: string) {
    const {data} = await axios.get(`${API_URL}/sgt/v1/evaluation_reports/${uuid}`)
    const evaluationReport: EvaluationReport = data.data
    setEvaluationReport(evaluationReport)
    if (evaluationReport.uuid) {
      formik.setFieldValue('uuid', evaluationReport.uuid)
    }
    if (evaluationReport.evaluation_report_number) {
      formik.setFieldValue('evaluation_report_number', evaluationReport.evaluation_report_number)
    }
    if (evaluationReport.type) {
      formik.setFieldValue('type', evaluationReport.type)
    }
    if (evaluationReport.status) {
      formik.setFieldValue('status', evaluationReport.status)
      if (evaluationReport.status === 'concluded') {
        setIsDisabledEnable(true)
        setIsConclude(true)
        setIsCanceled(false)
        setIsOpening(false)
      }
      if (evaluationReport.status === 'opened') {
        setIsOpening(true)
        setIsDisabledEnable(false)
        setIsConclude(false)
        setIsCanceled(false)
      }
      if (evaluationReport.status === 'canceled') {
        setIsDisabledEnable(true)
        setIsCanceled(true)
        setIsConclude(false)
        setIsOpening(false)
      }
    }
    if (evaluationReport.reference_year) {
      let initial = new Date(`${evaluationReport.reference_year}`)
      setYear(initial)
      formik.setFieldValue('reference_year', evaluationReport.reference_year)
    }
    if (evaluationReport.issue_date) {
      let initial = new Date(`${evaluationReport.issue_date} 12:00:00`)
      setissue_dateD(initial)
      formik.setFieldValue('issue_date', evaluationReport.issue_date)
    }
    if (evaluationReport.discount) {
      formik.setFieldValue('discount', parseFloat(evaluationReport.discount))
      setdiscount(parseFloat(evaluationReport.discount))
    }
    if (evaluationReport.observations) {
      formik.setFieldValue('observations', evaluationReport.observations)
    }
    if (evaluationReport?.property) {
      const property: any = {
        value: evaluationReport?.property.id,
        label: evaluationReport?.property.name,
      }
      setPropertyID(property)
      formik.setFieldValue('property_id', evaluationReport.property_id)
    }
    if (evaluationReport.costCenter) {
      setTimeout(() => {
        let costCenterArray: any = []
        let costCenterIdArray: any = []
        if (evaluationReport.costCenter) {
          evaluationReport.costCenter.map((cost) => {
            costCenterArray.push({
              code: cost.id,
              name: `${cost.name} - ${cost.description}`,
            })
            costCenterIdArray.push(cost.id)
            return {costCenterArray, costCenterIdArray}
          })
        }
        formik.setFieldValue('cost_center_id', costCenterIdArray)
        setSelectedCostCenters(costCenterArray)
      }, 3000)
    }
  }

  const formik = useFormik<EvaluationReport>({
    initialValues,
    validationSchema: evaluationReportSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        // await axios.put(`${API_URL}/sgt/v1/evaluation_reports/${values.uuid}`, values)
        await updateEvaluationReport(values)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'EVALUATION_REPORT.SWAL_EDIT'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/evaluationreports')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'EVALUATION_REPORT.SWAL_EDIT_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })
        setLoading(false)
      }
    },
  })

  async function ActionDeleteEvaluationReport(uuid: string) {
    deleteEvaluationReport(uuid)
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'EVALUATION_REPORT.SWAL_DELETE'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/evaluationReports', {replace: true})
      })
      .catch(() => {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'EVALUATION_REPORT.SWAL_DELETE_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })
      })
  }

  function deleteMsgevaluationReport() {
    MySwal.fire({
      title: intl.formatMessage({id: 'EVALUATION_REPORT.SWAL_DELETE_?'}),
      text: intl.formatMessage({id: 'COMMON.SWAL_DELETE_TEXT'}),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({id: 'COMMON.SWAL_DELETE_MSG'}),
      cancelButtonText: intl.formatMessage({id: 'COMMON.CANCEL_BUTTON'}),
    }).then((result) => {
      if (result.value) {
        if (uuid !== undefined) ActionDeleteEvaluationReport(uuid)
      }
    })
  }

  async function ActionConcludeEvaluationReport(id: any) {
    concludeEvaluationReport(id)
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'EVALUATION_REPORT.SWAL_CONCLUDED'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/evaluationReports', {replace: true})
      })
      .catch(() => {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'EVALUATION_REPORT.SWAL_DELETE_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })
      })
  }

  function concludeMsgevaluationReport() {
    MySwal.fire({
      title: intl.formatMessage({id: 'EVALUATION_REPORT.SWAL_CONCLUDED_?'}),
      text: intl.formatMessage({id: 'COMMON.SWAL_DELETE_TEXT'}),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({id: 'EVALUATION_REPORT.SWAL_CONCLUDED_MSG'}),
      cancelButtonText: intl.formatMessage({id: 'COMMON.CANCEL_BUTTON'}),
    }).then((result) => {
      if (result.value) {
        if (evaluation_report) ActionConcludeEvaluationReport(evaluation_report.id)
      }
    })
  }

  async function ActionEnableEvaluationReport() {
    if (evaluation_report?.id) {
      enableEvaluationReport(evaluation_report?.id)
        .then(() => {
          Swal.fire({
            icon: 'success',
            title: intl.formatMessage({id: 'EVALUATION_REPORT.SWAL_ENABLE'}),
            showConfirmButton: false,
            timer: 3000,
          })
          formik.setFieldValue('status', 'opened')
          setIsOpening(true)
          setIsConclude(false)
          setIsDisabledEnable(false)
          queryClient.invalidateQueries('evaluation-indemnity-areas-list-page=1&items_per_page=10')
        })
        .catch(() => {
          Swal.fire({
            icon: 'error',
            title: intl.formatMessage({id: 'EVALUATION_REPORT.SWAL_DELETE_ERROR'}),
            showConfirmButton: false,
            timer: 2000,
          })
        })
    }
  }

  async function ActionViewEvaluationReport() {
    if (evaluation_report?.property_id) {
      viewEvaluationReport(
        evaluation_report?.property_id,
        evaluation_report?.evaluation_report_number
      )
        .then(() => {
          Swal.fire({
            icon: 'success',
            title: intl.formatMessage({id: 'EVALUATION_REPORT.SWAL_ENABLE'}),
            showConfirmButton: false,
            timer: 3000,
          })
        })
        .catch(() => {
          Swal.fire({
            icon: 'error',
            title: intl.formatMessage({id: 'EVALUATION_REPORT.SWAL_DELETE_ERROR'}),
            showConfirmButton: false,
            timer: 2000,
          })
        })
    }
  }

  const loadOptionsPropertyID = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getProperties()

      let owners: any = []
      async function getProperties() {
        const {data} = await axios.get(API_URL + '/sgt/v1/properties/select2')
        let Response = data.results
        if (Response) {
          for (const element of Response) {
            const owner: any = {
              value: element.id,
              label: element.name,
            }
            owners.push(owner)
          }
        }
      }
      callback(owners)
    }, 1000)
  }

  const handleInputChangePropertyID = (event: any) => {
    let inputValue = ''
    inputValue = event.value
    formik.setFieldValue('property_id', inputValue.toString())
    getEvaluationReportNumber(parseInt(inputValue))
    setPropertyID(event)
    return {inputValue}
  }

  const setConvertDate = (e: any, typeDate: 'year' | 'date') => {
    let DateFormate: any
    switch (typeDate) {
      case 'date': {
        DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
        setissue_dateD(e)
        formik.setFieldValue('issue_date', DateFormate)
        break
      }
      case 'year': {
        DateFormate = moment(new Date(e)).format('YYYY')
        setYear(e)
        formik.setFieldValue('reference_year', DateFormate)
        break
      }
    }
  }

  insertDataTime()
  return (
    <>
      <div className='card card-custom mt-n8'>
        {/* Component Header de Cadastros. */}
        <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
        <PageTitle breadcrumbs={[]}>
          {intl.formatMessage({id: 'EVALUATION_REPORT.EDIT_TITLE'})}
        </PageTitle>

        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='d-flex justify-content-end mt-3 mb-5'>
            <div className='dropdown-center'>
              <button
                className='btn btn-sm btn-light fw-bold dropdown-toggle'
                type='button'
                data-bs-toggle='dropdown'
                aria-expanded='false'
              >
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                {intl.formatMessage({id: 'MENU.ACTIONS'})}
              </button>
              <ul className='dropdown-menu'>
                <li>
                  <button
                    type='button'
                    className={`${isOpening ? 'd-none' : ''} ${
                      isCanceled ? 'd-none' : ''
                    } dropdown-item fw-semibold download`}
                    onClick={ActionEnableEvaluationReport}
                  >
                    {intl.formatMessage({id: 'EVALUATION_REPORT.ENABLE_REPORT'})}
                  </button>
                </li>
                <li
                  className={`${isOpening ? 'd-none' : ''} ${
                    isCanceled ? 'd-none' : ''
                  } dropdown-divider`}
                ></li>
                <li>
                  <button
                    type='button'
                    className={`${isConclude ? 'd-none' : ''} ${
                      isCanceled ? 'd-none' : ''
                    } dropdown-item fw-semibold`}
                    onClick={concludeMsgevaluationReport}
                  >
                    {intl.formatMessage({id: 'COMMON.CONCLUDE'})}
                  </button>
                </li>
                <li
                  className={`${isConclude ? 'd-none' : ''} ${
                    isCanceled ? 'd-none' : ''
                  } dropdown-divider`}
                ></li>

                <li>
                  <button
                    type='button'
                    className={`dropdown-item fw-semibold`}
                    onClick={ActionViewEvaluationReport}
                  >
                    {intl.formatMessage({id: 'EVALUATION_REPORT.VIEW_EVALUATION_REPORT_TITLE'})}
                  </button>

                  <ModalCanceledReport
                    id='cancellation_reason'
                    show={canceledReportModal}
                    handleClose={() => setCanceledReportModal(false)}
                    data={evaluation_report}
                  />
                </li>
                <li className='dropdown-divider'></li>

                <li>
                  <button
                    type='button'
                    onClick={() => {
                      setCanceledReportModal(true)
                    }}
                    className={`${isDisabledEnable ? 'd-none' : ''} dropdown-item fw-semibold`}
                  >
                    {intl.formatMessage({id: 'EVALUATION_REPORT.CANCELLATION_REASON_TITLE'})}
                  </button>
                </li>
                <li className={`${isDisabledEnable ? 'd-none' : ''} dropdown-divider`}></li>

                <li>
                  <button
                    id='kt_delete_evaluation_report'
                    type='button'
                    className='dropdown-item dropdown-item fw-semibold'
                    onClick={deleteMsgevaluationReport}
                  >
                    {intl.formatMessage({id: 'COMMON.DELETE_BUTTON'})}
                  </button>
                </li>
              </ul>
            </div>
            <button
              type='submit'
              className='btn btn-sm btn-primary mx-2'
              disabled={loading || isDisabledEnable}
            >
              {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
              {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>

          <div className='mx-7 mb-5 mt-n4 '>
            <div className='col-lg-12 mb-1'>
              {/* INICIO LINHA 01*/}
              <div className='row mb-1'>
                <div className='col-lg-6'>
                  <label className={`col-form-label fw-bold fs-6`}>
                    {intl.formatMessage({id: 'EVALUATION_REPORT.NUMBER'})}
                  </label>

                  <input
                    type='text'
                    className='form-control form-control-lg form-control text-gray-400'
                    disabled
                    size={100}
                    {...formik.getFieldProps('evaluation_report_number')}
                  />
                </div>

                <div className='col-lg-6'>
                  <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                    {intl.formatMessage({id: 'PROPERTIES.TITLE'})}
                  </label>
                  <AsyncSelect
                    className={`form-control form-control-lg form-control-solid p-1 ps-3 ${
                      isDisabledEnable ? 'text-gray-400' : ''
                    }`}
                    styles={colourStyles}
                    components={animatedComponents}
                    cacheOptions
                    isDisabled={isDisabledEnable}
                    value={propertyID}
                    loadOptions={loadOptionsPropertyID}
                    filterOption={(option, inputValue) =>
                      option.label
                        ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                        : false
                    }
                    defaultOptions
                    onChange={handleInputChangePropertyID}
                    placeholder={intl.formatMessage({
                      id: 'PROPERTIES.TITLE',
                    })}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                      },
                    })}
                  />
                </div>
              </div>
            </div>

            <div className='col-lg-12 mb-1'>
              {/* INICIO LINHA 01*/}
              <div className='row mb-1'>
                <div className='col-lg-6'>
                  <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                    {intl.formatMessage({id: 'COMMON.TYPE'})}
                  </label>
                  <select
                    className={`form-select fs-6 form-select-solid form-select-lg fw-bold ${
                      isDisabledEnable ? 'text-gray-400' : ''
                    }`}
                    disabled={isDisabledEnable}
                    {...formik.getFieldProps('type')}
                  >
                    <option className='text-gray-400'>Selecione o Tipo</option>
                    <option value='annual_servitude'>
                      {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.ANNUAL_SERVITUDE'})}
                    </option>
                    <option value='single_servitude'>
                      {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.SINGLE_SERVITUDE'})}
                    </option>
                    <option value='direct_damage'>
                      {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.DIRECT_DAMAGE'})}
                    </option>
                    <option value='business_interruption'>
                      {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.BUSINESS_INTERRUPTION'})}
                    </option>
                  </select>
                  {formik.touched.type && formik.errors.type && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.type}</div>
                    </div>
                  )}
                </div>

                <div className='col-lg-6'>
                  <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                    {intl.formatMessage({id: 'COMMON.STATUS'})}
                  </label>
                  <select
                    className={`form-select fs-6 form-select-solid form-select-lg fw-bold ${
                      isDisabledEnable ? 'text-gray-400' : ''
                    }`}
                    disabled={isDisabledEnable}
                    {...formik.getFieldProps('status')}
                  >
                    <option className='text-gray-400'>Selecione o Status</option>
                    <option value='opened'>
                      {intl.formatMessage({id: 'EVALUATION_REPORT.STATUS_OPENED'})}
                    </option>
                    <option value='concluded'>
                      {intl.formatMessage({id: 'EVALUATION_REPORT.STATUS_CONCLUDED'})}
                    </option>
                    <option value='canceled'>
                      {intl.formatMessage({id: 'EVALUATION_REPORT.STATUS_CANCELED'})}
                    </option>
                  </select>
                  {formik.touched.status && formik.errors.status && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.status}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className='col-lg-12 mb-1'>
              {/* INICIO LINHA 01*/}
              <div className='row mb-1'>
                <div className='col-lg-6'>
                  <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                    {intl.formatMessage({id: 'COMMON.YEAR'})}
                  </label>
                  <Calendar
                    inputClassName='form-control form-control-solid fs-5 ps-6 fw-bold border-white'
                    style={{
                      width: '100%',
                    }}
                    id='yearpicker'
                    view='year'
                    dateFormat='yy'
                    onChange={(e: any) => setConvertDate(e.value, 'year')}
                    value={year}
                    disabled={isDisabledEnable}
                  />
                </div>
                <div className='col-lg-6'>
                  <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                    {intl.formatMessage({id: 'LICENSES.ISSUE_DATE'})}
                  </label>
                  <Calendar
                    value={issue_dateD}
                    onChange={(e: any) => setConvertDate(e.value, 'date')}
                    selectionMode='single'
                    inputClassName='form-control form-control-solid fs-5 ps-6 fw-bold border-white'
                    style={{
                      width: '100%',
                    }}
                    dateFormat='dd/mm/yy'
                    placeholder='dd/mm/aaaa'
                    showButtonBar
                    disabled={isDisabledEnable}
                  />
                </div>
              </div>
            </div>

            <div className='col-lg-12 mb-1'>
              {/* INICIO LINHA 01*/}
              <div className='row mb-1'>
                <div className='col-lg-6'>
                  <label className='col-lg-12 col-form-label  fw-bold fs-6'>
                    {intl.formatMessage({id: 'COST_CENTER.TITLE'})}
                  </label>
                  <MultiSelect
                    className='form-control form-control-lg form-control-solid p-1 pl-1 border border-white'
                    value={selectedCostCenters}
                    options={costCenters}
                    style={{
                      fontFamily: 'Poppins',
                      fontSize: '1.15rem',
                      fontWeight: 'medium',
                    }}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'cost_center_id',
                        e.value.map((v: any) => {
                          return v.code
                        })
                      )

                      setSelectedCostCenters(e.value)
                    }}
                    placeholder={intl.formatMessage({
                      id: 'COST_CENTER.TITLE',
                    })}
                    optionLabel='name'
                    filter
                    display='chip'
                    disabled={isDisabledEnable}
                  />
                </div>
                <div className='col-lg-6'>
                  <label className='col-lg-12 col-form-label  fw-bold fs-6'>
                    {intl.formatMessage({id: 'EVALUATION_REPORT.DISCOUNT'})}
                  </label>
                  <CurrencyInput
                    className={`form-control form-control-lg form-control-solid ${
                      isDisabledEnable ? 'text-gray-400' : ''
                    }`}
                    name='discount'
                    intlConfig={{locale: 'pt-BR', currency: 'BRL'}}
                    decimalScale={2}
                    allowDecimals={true}
                    value={discount}
                    onValueChange={(value) => {
                      setdiscount(value)
                      return formik.setFieldValue('discount', value?.replace(',', '.') || 0)
                    }}
                    placeholder={intl.formatMessage({
                      id: 'EVALUATION_REPORT.DISCOUNT_PLACEHOLDER',
                    })}
                    disabled={isDisabledEnable}
                  />
                </div>
              </div>
            </div>
            <div className='col-lg-12 mb-1'>
              <label className='col-lg-12 col-form-label  fw-bold fs-6'>
                {intl.formatMessage({id: 'CONDITIONINGS.OBSERVATION'})}
              </label>
              {/* INICIO LINHA 01*/}
              <textarea
                className={`form-control form-control-lg form-control-solid 
                ${isDisabledEnable ? 'text-gray-400' : ''}`}
                id='observations'
                disabled={isDisabledEnable}
                cols={5}
                rows={2}
                {...formik.getFieldProps('observations')}
              ></textarea>
            </div>
          </div>
        </form>
      </div>

      {evaluation_report !== undefined && (
        <EvaluationIndemnityAreaList data={evaluation_report} isDisabled={isDisabledEnable} />
      )}
    </>
  )
}

export {FormEvaluationReportEdit}
